import { getDataMapper, mapField } from "@/shared";

export const mapSellingProductToServer = getDataMapper(
    {
        product_id: mapField("product", (p) => p.id),
        count: mapField("count", Number),
    },
    { shouldAvoidUndefined: true }
);
